export default [
  {
    // the backend shares links as .../signup?referral=… but the real route
    // here is /auth/signup, so redirect preserving the query string
    path: '/signup',
    redirect: to => ({ name: 'AuthSignUp', query: to.query })
  },
  {
    path: '/auth/signin',
    name: 'AuthSignIn',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/SignIn.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      title: 'Inicio de sesión'
    }
  },
  {
    path: '/auth/signup',
    name: 'AuthSignUp',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/SignUp.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      title: 'Registro de usuario'
    }
  },
  {
    path: '/auth/settings',
    name: 'AuthSettings',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Settings.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: true,
      requireAuth: true,
      title: 'Configuraciones de usuario'
    }
  },
  {
    path: '/auth/password/reset',
    name: 'AuthPasswordReset',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/PasswordReset.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      title: 'Restablecimiento de la contraseña'
    }
  },
  {
    path: '/auth/password/reset/confirm/:uid/:token',
    name: 'AuthPasswordResetConfirm',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/PasswordResetConfirm.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      title: 'Confirmación restablecimiento de la contraseña'
    }
  }
]